import React from 'react';
import { colors, type, space, elevation } from '../tokens';
import Avatar from './Avatar';
import StatusChipStrip from './StatusChipStrip';
import EngagementGauge from './EngagementGauge';
import DonorScoreBadge from './DonorScoreBadge';
import QuickActionBar from './QuickActionBar';

const DonorHero = ({ contact, onAction, sticky = true }) => {
  if (!contact) return null;

  const fullName = `${contact.firstName} ${contact.lastName}`;
  const preferred = contact.preferredName && contact.preferredName !== contact.firstName
    ? ` "${contact.preferredName}"` : '';
  const location = [contact.city, contact.state].filter(Boolean).join(', ');

  return (
    <header
      style={{
        position: sticky ? 'sticky' : 'static',
        top: 0,
        zIndex: 10,
        background: colors.surface,
        borderBottom: `1px solid ${colors.border}`,
        boxShadow: elevation.sticky,
        padding: `${space[4]}px ${space[6]}px`,
      }}
    >
      <div style={{
        display: 'flex',
        gap: space[5],
        alignItems: 'center',
        flexWrap: 'wrap',
      }}>
        <Avatar initials={contact.avatarInitials} color={contact.avatarColor} size="lg" />

        <div style={{ flex: '1 1 420px', minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: space[2], flexWrap: 'wrap' }}>
            <h1 style={{ ...type.h1, color: colors.textPrimary, margin: 0 }}>
              {fullName}{preferred}
            </h1>
            {contact.pronouns && (
              <span style={{ ...type.small, color: colors.textTertiary }}>
                {contact.pronouns}
              </span>
            )}
            {contact.title && (
              <>
                <span style={{ color: colors.border }}>·</span>
                <span style={{ ...type.small, color: colors.textTertiary }}>{contact.title}</span>
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: space[3], flexWrap: 'wrap', marginTop: space[2] }}>
            {contact.email && (
              <span style={{ ...type.small, color: colors.textSecondary }}>
                {contact.email}
              </span>
            )}
            {contact.phone && (
              <>
                <span style={{ color: colors.border }}>·</span>
                <span style={{ ...type.small, color: colors.textSecondary }}>{contact.phone}</span>
              </>
            )}
            {location && (
              <>
                <span style={{ color: colors.border }}>·</span>
                <span style={{ ...type.small, color: colors.textSecondary }}>{location}</span>
              </>
            )}
          </div>
          <div style={{ marginTop: space[3] }}>
            <StatusChipStrip chips={contact.statusChips} />
          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: space[2],
        }}>
          <EngagementGauge score={contact.engagementScore} />
          <DonorScoreBadge score={contact.donorScore} breakdown={contact.scoreBreakdown} />
        </div>
      </div>

      <div style={{ marginTop: space[4] }}>
        <QuickActionBar onAction={onAction} size="md" />
      </div>
    </header>
  );
};

export default DonorHero;
